<template lang="pug">
  div
    TextBox.mt-0.pt-1(
      only-number,
      label="Code",
      :value.sync="model.code",
      @enter="wrapProgress(submit)",
    )
    v-btn.mt-4(
      color="primary",
      :disabled="hasError || !valid",
      :ripple="false",
      :loading="isLoading",
      @click="wrapProgress(submit)",
    ) Access
</template>

<script>
import { formHelper } from '@/config/mixins.js';

export default {
  props: {
    loginFn: {
      type: Function,
      rquired: true,
    },
  },

  mixins: [formHelper],

  methods: {
    submit() {
      if (this.validate()) {
        this.loginFn(this.model);
      }
    },
  },
};
</script>
